import axios from "axios";
import { baseURL } from "./apiConstants";
import { ErrorToast } from "../widgets/AppToast";

const axiosData = {
  baseURL: baseURL,
  timeout: 12000,
  withCredentials: true,
};

var instance = axios.create(axiosData);
// Add a request interceptor
instance.interceptors.request.use(
  async (config) => {
    // console.log("config ************", config?.url, "****", config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
let toastShown = false;
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.data?.code === "subscription_required") {
      window.dispatchEvent(new CustomEvent("subscription-required", {
        detail: error.response.data.data.subscription,
      }));
      return Promise.reject(error);
    }
    if (!toastShown) {
      let errorMessage = "An error occurred while fetching data.";
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message === 'Network Error') {
        errorMessage = "Network connection lost. Please check your internet.";
      } else if (error?.response?.status >= 500) {
        errorMessage = "Server encountered an error. Please try again later.";
      }

      ErrorToast("Error", errorMessage);
      toastShown = true;
      setTimeout(() => {
        toastShown = false;
      }, 3000);
    }
    return Promise.reject(error);
  }
);

export default instance;
